// extracted by mini-css-extract-plugin
module.exports = {"wrapper_big":"loading_wrapper_big__EaQO-","wrapper_medium":"loading_wrapper_medium__3VcJk","wrapper_p":"loading_wrapper_p__1Xm1t","wrapper_small":"loading_wrapper_small__24QPB"};